import { Listing } from '@zoopla/listing-search-queries';

export type FeedListingItem = {
    listing: Listing;
    presentationType: string;
};

export type ResultsItem = {
    data: FeedListingItem;
    type: string;
};

export enum SearchType {
    ForSale = 'for-sale',
    ToRent = 'to-rent',
    NewHomes = 'new-homes'
}
export type SearchPageType = SearchType | 'for-sale' | 'to-rent' | 'new-homes';
